import { Component, Input } from '@angular/core';
import { MensagemProvider } from 'src/app/services/mensagem/mensagem';
import { NoticiaProvider } from 'src/app/services/noticia/noticia';
import { OracaoProvider } from 'src/app/services/oracao/oracao';
import { UserProvider } from 'src/app/services/user/user';
import { BotaoConfig } from '../../interfaces/aplicativo.interface';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

@Component({
  selector: 'botao-escrito',
  templateUrl: 'botao-escrito.html',
  styleUrls: ['botao-escrito.scss'],
  standalone: true,
  imports: [
    CommonModule,
    IonicModule
  ]
})
export class BotaoEscritoComponent {

  @Input()
  config!: BotaoConfig;

  constructor(public mensagemProvider: MensagemProvider,
    public oracaoProvider: OracaoProvider,
    public noticiaProvider: NoticiaProvider,
    public userProvider: UserProvider, ) {

  }

  getBackground() {
    return this.config.icon_backcolor;
  }

  getSize() {
    return this.config.tamanho == 1 ? '90%' : '98%';
  }

  getFontColor() {
    return this.config.font_color;
  }

  getFontSize() {
    return this.config.font_size + 'px';
  }

  getFontWeight() {
    return this.config.font_weight + 100;
  }

  getFontAlign() {
    return this.config.font_align;
  }

  getBorder() {
    return this.config.border_size + 'px solid ' + this.config.border_color;
  }

  getIconSize() {
    return this.config.icon_size + 'px';
  }

}
